import {kontStammFetchAction, kontStammResponseAction} from 'module/KontStamm/KontStammAction'
import {filter, mergeMap} from 'rxjs/operators'
import {Epic} from 'redux-observable'
import {selKontStammByPersNr} from 'module/KontStamm/KontStammSelector'
import {getKontStammAPI} from 'module/KontStamm/KontStammAPI'
import {getSisDateAsNumber, parseSisDate} from 'util/SisDateTime'
import {catchServerError} from 'module/ConfirmDialog/component/ConfirmDialogContainer'
import moment from 'moment'

const FetchEpic: Epic = (action$, state$) => action$.pipe(
	filter(kontStammFetchAction.match),
	mergeMap(({payload}) => {
		let {persNrs, startDate, endDate, force} = payload
		const byPersNr = selKontStammByPersNr(state$.value)
		if (!force) {
			const minTS = +moment().add(-1, 'day')
			persNrs = persNrs.filter(persNr => {
				let s = startDate
				let e = endDate
				byPersNr[persNr]?.fetchTS.forEach(x => {
					if (x.ts < minTS || s > e) return
					if (s <= x.end && e >= x.start) {
						// overlaps
						if (s <= x.start) s = getSisDateAsNumber(parseSisDate(x.start).add(1, 'day'))
						if (e >= x.end) e = getSisDateAsNumber(parseSisDate(x.end).subtract(1, 'day'))
					}
				})
				return s <= e
			})
		}
		return getKontStammAPI(persNrs, startDate, endDate).then(({data}) => kontStammResponseAction({params: payload, response: data}))
	}, 1),
	catchServerError(),
)

export const KontStammEpic = FetchEpic